import React from 'react';
import { FormGroup, FormControl } from 'react-bootstrap';
import { base_price } from './Buy'

class PaypalCheckout extends React.Component {

	constructor(props) { 
		super(props);
		this.state = {hideButton: false};
		this.hideButton = this.hideButton.bind(this);
	}

	hideButton() { 
		this.setState({hideButton: true});
	}

	componentDidMount() { 
		let getPrice = this.props.fetchPrice;
		let getCurrency = this.props.fetchCurrency;
		let onClick = this.props.onClick;
		let onPaymentConfirmed = this.props.onPaymentConfirmed;
		let hideButton = this.hideButton;
		let getLicenses = this.props.fetchLicense;

		window.paypal.Button.render({
			env: 'production',
			client: { 
				sandbox: 'AfwcpQhopzrMWg6lyy6gi7K39kzpJYhPAK601f5mX2ci5G3F-OcouIiBoVJNX2UbQtdOI-dnAcDfsMd1',
				production: 'AdIJc6xemxoymCwb1X4iVnkGAgBI1oAJgtPLY4wfh1XZq3NfWXnDZOZm7_mvrb_1xX3zl28kcX86hFDP'
			},

			payment: function() {
				onClick();
				hideButton();

				var env    = this.props.env;
            	var client = this.props.client;
        		
        		var tx = { transactions: [
	                    {
	                        amount: { total: getPrice(), currency: getCurrency() },
	                        description: 'Purchase of Splinter License',
	                        item_list: { items: [{ name: 'Splinter Licenses', price: base_price, currency: getCurrency(), quantity: getLicenses()}]}
	                    }
	                ]};
	            return window.paypal.rest.payment.create(env, client, tx);
			},

			onAuthorize: function(data, actions) {
				const paypalPaymentId = document.getElementById('paypalPaymentId');
				paypalPaymentId.setAttribute('value', data.paymentID);

				const paypalPayerId = document.getElementById('paypalPayerId');
				paypalPayerId.setAttribute('value', data.payerID);

				onPaymentConfirmed(null);
			}
		}, '#paypal-button');
	}

	componentWillUnmount() {

	}

	render() { 
		return (
			<FormGroup>
			      <div id="paypal-button" className={this.state.hideButton === true ? 'hidden' : ''}></div>
			      
			      <FormControl type="hidden" id="paypalPaymentId" name="paypalPaymentId"/>
			      <FormControl type="hidden" id="paypalPayerId" name="paypalPayerId"/>
		    </FormGroup>
			);
	}
}

export default PaypalCheckout;


// WEBPACK FOOTER //
// ./src/PaypalCheckout.js